import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-archive-icon',
  templateUrl: 'archive-icon.component.html'
})
export class ArchiveIconComponent {
  constructor() {}
}
